import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import classNames from 'classnames';

import { RootState } from '../../../../configs/store';
import { Market } from '../../../../interfaces/EventsState';
import formatOdds from '../../../../utils/formatOdds';
import Icon from 'src/components/Icon/Icon';
import useOnScreen from 'src/hooks/useOnScreen';

interface LayoutType4Props {
  market: Market,
  removeFromBetslip: Function,
  addToBetslip: Function,
  isSuspended: boolean
}

function LayoutType4({ market, removeFromBetslip, addToBetslip, isSuspended }: LayoutType4Props) {
  const { selectedEvent, liveOutcomes } = useSelector((state: RootState) => state.events);
  const { bets } = useSelector((state: RootState) => state.betslip);
  const { selectedOddsType } = useSelector((state: RootState) => state.odds);
  const refOdds = useRef(null);
  const dispatch = useDispatch();
  const isVisible = useOnScreen(refOdds, '0px');

  useEffect(() => {
    for (const outcome of market.outcomes){
      if (outcome && isVisible && !(liveOutcomes.includes(outcome.code))){
        dispatch.events.addEventToLiveOutcomes([outcome.code]);
      } else if (outcome && !isVisible && liveOutcomes.includes(outcome.code)){
        dispatch.events.removeFromLiveOutcomes([outcome.code]);
      }
    }
  }, [isVisible]);

  return (
    <div className="event-table__markets event-table__markets--single">
      <h1 className="event-table__title">{ market.name }</h1>
      <div className="event-table__container">
        {
          _.map(market.outcomes, (outcome) => {
            const index = _.findIndex(bets, {
              eventCode: parseInt(selectedEvent.code),
              marketCode: outcome.marketCode,
              marketOutcomeCode: outcome.code
            });
            const isBlocked = market.statusNumber === 3 || outcome.statusNumber === 3 || isSuspended;
            return (
              <div
                ref= { refOdds }
                className={
                  classNames({
                    'event-table__outcomes': true,
                    'event-table__outcomes--blocked': isBlocked
                  })
                }
                key={ market.name + outcome.shortName }
              >
                <div
                  className={
                    classNames({
                      'event-table__item': true,
                      'event-table__item--word-break': true,
                      'event-table__item--selected': index !== -1,
                      'event-table__outcomes--increased': outcome['oddsChanged'] === 'increased',
                      'event-table__outcomes--decreased': outcome['oddsChanged'] === 'decreased',
                      'event-table__item--decreased': outcome['oddsChanged'] === 'decreased',
                      'event-table__item--increased': outcome['oddsChanged'] === 'increased'
                    })
                  }
                  onClick={
                    index !== -1 ?  () => removeFromBetslip(index) : () => addToBetslip(market, outcome)
                  }
                >
                  { outcome['oddsChanged'] === 'increased' && <span className="event-row__arrow event-row__arrow--increased" /> }
                  { outcome['oddsChanged'] === 'decreased'   && <span className="event-row__arrow event-row__arrow--decreased" /> }
                  <span className={
                    classNames({
                      'event-table__item--name': true,
                      'event-table__outcomes--increased': outcome['oddsChanged'] === 'increased',
                      'event-table__outcomes--decreased': outcome['oddsChanged'] === 'decreased',
                      'event-table__item--decreased': outcome['oddsChanged'] === 'decreased',
                      'event-table__item--increased': outcome['oddsChanged'] === 'increased'
                    })
                  }
                  >{ outcome?.shortName }</span>
                </div>
                <div
                  className={
                    classNames({
                      'event-table__item': true,
                      'event-table__item--selected': index !== -1,
                      'event-table__item--decreased': outcome['oddsChanged'] === 'decreased',
                      'event-table__item--increased': outcome['oddsChanged'] === 'increased'
                    })
                  }
                  onClick={
                    index !== -1 ?  () => removeFromBetslip(index) : () => addToBetslip(market, outcome)
                  }
                >
                  { isBlocked && <Icon icon="padlock" className="event-table__outcomes--icon" /> }
                  <span className="event-table__item--value">
                    { formatOdds(outcome?.value, selectedOddsType) }</span>
                </div>
              </div>
            );
          })
        }
      </div>
    </div>
  );
}

export default LayoutType4;
